import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import './contact.styles.css';

const Contact = () => (
    <div id="contact">
    <Container fluid className="contact">
        <div className="unskew-contact">
            <Row className="d-flex justify-content-center text-center">
                <h2 className="get-in-touch">Get in Touch</h2>
            </Row>
            <Row className="d-flex justify-content-center text-center">
                <p className="open">I’m open to collaboration and job opportunities.</p>
            </Row>
            <Row className="d-flex justify-content-center text-center">
                <p className="contact-links">
                <a rel="noreferrer" href="mailto:gitasujatmiko@gmail.com" target="_blank" className="mail-me">
                    gitasujatmiko@gmail.com
                </a>
                <br/>
                <a rel="noreferrer" href="https://www.linkedin.com/in/gitasujatmiko/" target="_blank">
                <i class="fab fa-linkedin"></i>
                </a>
                <a rel="noreferrer" href="https://github.com/gpersable" target="_blank">
                <i class="fab fa-github"></i>
                </a>
                </p>
            </Row>
        </div>

    </Container>
    </div>
);

export default Contact;